import { bool, string } from 'prop-types';

export const CollectionPropTypes = {
  collectionId: string.isRequired,
  preview: bool
};

export const CollectionDefaultProps = {
  preview: false
};
